// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	LoginForm: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "LoginForm" */
				'./index'
			),
	} ),
};
